import { ICollectionTemplateList, TEMPLATE_CATEGORY } from '@/sharedComponents/CollectionSettingsComponents/collectionViewTemplates/types';
import {
  createContext, Dispatch, ReactNode, SetStateAction, useState, useMemo,
} from 'react';
import { Path } from 'slate';

interface CollectionTemplate {
  sidebarOpen: boolean
  setsidebarOpen: Dispatch<SetStateAction<boolean>> | undefined
  templatePath: Path | undefined | null
  settemplatePath: Dispatch<SetStateAction<Path | null>> | undefined
  selectedTemplate: ICollectionTemplateList | undefined | null
  setselectedTemplate: Dispatch<SetStateAction<ICollectionTemplateList | null>> | undefined
  hovered: ICollectionTemplateList | undefined | null
  sethovered: Dispatch<SetStateAction<ICollectionTemplateList | null>> | undefined
  selectedCategory: TEMPLATE_CATEGORY | undefined
  setselectedCategory: Dispatch<SetStateAction<TEMPLATE_CATEGORY | null>> | undefined
}

export const CollectionTemplateContext = createContext<CollectionTemplate>({
  sidebarOpen: false,
  setsidebarOpen: undefined,
  templatePath: undefined,
  settemplatePath: undefined,
  selectedTemplate: undefined,
  setselectedTemplate: undefined,
  selectedCategory: undefined,
  setselectedCategory: undefined,
  hovered: undefined,
  sethovered: undefined,

});

export const CollectionTemplateSidebarContext = createContext<boolean>(
  false,
);

export const CollectionTemplateSidebarDispatchContext = createContext<Dispatch<
SetStateAction<boolean>>>(() => false);

export function
CollectionTemplateProvider({
  children,
}: {
  children: ReactNode }) {
  const [sidebarOpen, setsidebarOpen] = useState(false);
  const [templatePath, settemplatePath] = useState<Path | null>(null);
  const [selectedTemplate, setselectedTemplate] = useState<ICollectionTemplateList | null>(null);
  const [selectedCategory, setselectedCategory] = useState<TEMPLATE_CATEGORY | null>(null);
  const [hovered, sethovered] = useState<ICollectionTemplateList | null>(null);

  return (
    <CollectionTemplateContext.Provider value={useMemo(
      () => ({
        sidebarOpen,
        setsidebarOpen,
        templatePath,
        settemplatePath,
        selectedTemplate,
        setselectedTemplate,
        selectedCategory,
        setselectedCategory,
        sethovered,
        hovered,
      }),
      [sidebarOpen, templatePath, selectedTemplate, selectedCategory, hovered],
    )}
    >
      {children}
    </CollectionTemplateContext.Provider>
  );
}
